module.exports = __webpack_public_path__ + "img/none.f62c2b01.png";